function Map() {
	return (
		<div className="mb-map">
			<iframe
				title="map"
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2894.1092145581947!2d-79.66363952396695!3d43.50005716232241!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b4335280f47ab%3A0x60b62f2092e87d9f!2sMane%20and%20Bare%20Hair%20Skin%20wellness!5e0!3m2!1sen!2sca!4v1758507425191!5m2!1sen!2sca"
				width="100%"
				height="600"
				style={{ border: 0 }}
				allowFullScreen=""
				loading="lazy"
				referrerPolicy="no-referrer-when-downgrade"
			></iframe>
		</div>
	);
}

export default Map;
